/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ delta: NonNullable<unknown> }} Body_Measures_ChangeInputs */

const en_us2_body_measures_change = /** @type {(inputs: Body_Measures_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} cm since the last one`)
};

const pt_br2_body_measures_change = /** @type {(inputs: Body_Measures_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} cm desde a anterior`)
};

const es_419_body_measures_change = /** @type {(inputs: Body_Measures_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} cm desde la anterior`)
};

const pt_pt2_body_measures_change = /** @type {(inputs: Body_Measures_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} cm desde a anterior`)
};

const fr_fr2_body_measures_change = /** @type {(inputs: Body_Measures_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} cm depuis la précédente`)
};

const de_de2_body_measures_change = /** @type {(inputs: Body_Measures_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} cm seit der letzten Messung`)
};

const it_it2_body_measures_change = /** @type {(inputs: Body_Measures_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} cm dalla precedente`)
};

/**
* | output |
* | --- |
* | "{delta} cm since the last one" |
*
* @param {Body_Measures_ChangeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_change = /** @type {((inputs: Body_Measures_ChangeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_ChangeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_change(inputs)
	if (locale === "es-419") return es_419_body_measures_change(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_change(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_change(inputs)
	if (locale === "de-DE") return de_de2_body_measures_change(inputs)
	if (locale === "it-IT") return it_it2_body_measures_change(inputs)
	return en_us2_body_measures_change(inputs)
});
export { body_measures_change as "body-measures.change" }